/* 🤖 this file was generated by svg-to-ts */
export const mgcIconText2Regular: {
  name: 'text-2-regular';
  data: string;
} = {
  name: 'text-2-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.673 4.063c-.244.075-.523.351-.609.603-.094.277-.094 2.391 0 2.668.124.363.549.666.936.666.237 0 .514-.12.697-.303.251-.251.303-.448.303-1.144V6h5v13h-.553c-.694 0-.893.052-1.141.3a.96.96 0 0 0 0 1.4c.302.302.287.3 2.694.3 2.411 0 2.391.002 2.697-.303.183-.183.303-.46.303-.697s-.12-.514-.303-.697c-.251-.251-.448-.303-1.144-.303H13V6h5v.573c0 .692.048.869.306 1.127.18.179.458.3.694.3.402 0 .827-.312.939-.69.088-.297.088-2.323 0-2.62a1.004 1.004 0 0 0-.629-.629c-.301-.09-14.346-.087-14.637.002"/></svg>`
};
